export default "__VITE_ASSET__sDndeVim__"